export default __webpack_public_path__ + "static/media/23_table.c4169d82.svg";